import { render, staticRenderFns } from "./BraceEditor.vue?vue&type=template&id=6d6f0072"
import script from "./BraceEditor.vue?vue&type=script&lang=js"
export * from "./BraceEditor.vue?vue&type=script&lang=js"
import style0 from "./BraceEditor.vue?vue&type=style&index=0&id=6d6f0072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports